import * as React from "react";
const SvgFilterAdd20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M20 4.803a4.803 4.803 0 0 1-6.617 4.449l-1.344 1.792v6.815l-5.557 2.084v-8.899L0 2.401h11.037A4.803 4.803 0 0 1 20 4.803Zm-9.575-.55h-6.72l4.63 6.174v6.843l1.851-.694v-6.15l1.647-2.195a4.789 4.789 0 0 1-1.408-3.978Zm3.772 1.55v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2Z",
      clipRule: "evenodd"
    })
  );
export default SvgFilterAdd20Px;
